import BoxIcon from "@redotech/redo-icons/box-01.svg";
import { NumberFilterOperator } from "@redotech/redo-model/views/advanced-filters/number-filter";
import { fgWmsFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgWmsFilterEntries.pickableBinCount;

export const PickableBinCountFilter: AdvancedTableFilter = {
  type: entry.type,
  Icon: BoxIcon,
  min: 0,
  data: {
    name: entry.name,
    type: entry.type,
    value: null,
    operator: NumberFilterOperator.LESS_THAN,
  },
  displayName: entry.displayName,
};
